/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsWithOrgData } from '../../models/submissions-with-org-data';

export interface GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Params {
  org: string;
}

export function getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet(http: HttpClient, rootUrl: string, params: GetSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsWithOrgData>>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsWithOrgData>>;
    })
  );
}

getSubmissionsOwnedBySecretariatApiV2SubmissionsOrgSecretariatSubmissionsGet.PATH = '/api/v2/submissions/{org}/secretariat/submissions';
